import type { ServicesResourcesTranslationMessages } from './servicesResourcesTranslationMessages';

export const servicesResourcesLanguageFrench: ServicesResourcesTranslationMessages = {
  soundfiles: {
    name: 'Fichiers audio',
    description: 'Lister et gérer tous vos fichiers audio',
    fields: {
      id: 'ID',
      description: 'Description',
      fileUploadHint: `Déposez un fichier audio ou cliquez pour le sélectionner.\nFichiers acceptés : .mp3, .wav`,
      name: 'Nom',
      labels: { id: 'Étiquettes', name: 'Étiquettes' },
    },
    errors: {
      fileInvalid: "Le format du fichier n'est pas valide",
      fileTooBig: 'La taille du fichier est trop importante',
      fileNotFound: 'Fichier audio introuvable, veuillez réessayer',
      generic: 'Erreur de téléchargement, veuillez réessayer',
    },
    operations: {
      create: 'Ajouter un fichier audio',
      delete: 'Supprimer le fichier audio',
      edit: 'Modifier le fichier audio',
      sections: {
        details: 'Informations sur le fichier audio',
      },
    },
    serviceButtonLabel: 'Gérer',
  },
};
